// 時間フォーマット用のユーティリティ関数

// 開始時刻のフォーマット（24時間表記）
export const formatStartTime = (startTime) => {
  const date = new Date(startTime);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};

// モーダル用の日時フォーマット（月/日 開始時刻）
export const formatDateTimeStart = (startTime) => {
  const start = new Date(startTime);
  const month = String(start.getMonth() + 1).padStart(2, '0');
  const day = String(start.getDate()).padStart(2, '0');
  const time = formatStartTime(startTime);
  
  return `${month}/${day} ${time}`;
};

// モーダル用の日時フォーマット（ライブ状態対応）
export const formatDateTimeWithLiveStatus = (startTime, isLive) => {
  const start = new Date(startTime);
  const month = String(start.getMonth() + 1).padStart(2, '0');
  const day = String(start.getDate()).padStart(2, '0');
  const time = formatStartTime(startTime);
  
  if (isLive) {
    return `${month}/${day} ${time} 〜 ON AIR`;
  }
  
  return `${month}/${day} ${time}`;
};
